// extracted by mini-css-extract-plugin
export default {"container":"Fea-z","list":"Gea-z"};